import { initClient } from '@ts-rest/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EMPTY, firstValueFrom, fromEvent, takeUntil } from 'rxjs';
import { nullThrows } from '@thred/shared-common';
import { AppRouter } from '@ts-rest/core/src/lib/dsl';

export function getTsRestClient<T extends AppRouter>(
  baseUrl: string,
  contract: T,
  httpClient: HttpClient,
) {
  return initClient(contract, {
    baseUrl,
    baseHeaders: {},
    api: async ({ path, method, headers, body, fetchOptions }) => {
      const abortObservable = fetchOptions?.signal
        ? fromEvent(fetchOptions.signal, 'abort')
        : EMPTY;
      try {
        const result = await firstValueFrom(
          httpClient
            .request(method, path, {
              headers,
              body,
              observe: 'response',
            })
            .pipe(takeUntil(abortObservable)),
        );

        const convertedHeaders = new Headers();
        result.headers.keys().forEach((key) => {
          const value = nullThrows(result.headers.get(key));
          convertedHeaders.append(key, value);
        });

        return {
          status: result.status,
          body: result.body,
          headers: convertedHeaders,
        };
      } catch (e) {
        if (e instanceof HttpErrorResponse) {
          const convertedHeaders = new Headers();
          for (const key of e.headers.keys()) {
            convertedHeaders.append(key, e.headers.get(key)!);
          }

          return {
            status: e.status,
            body: e.error,
            headers: convertedHeaders,
          };
        }
        throw e;
      }
    },
  });
}
